import React, { useEffect, useRef, useState } from 'react'
import { View, Text, ScrollView, FlatList, TouchableOpacity, Image, TextInput, Linking, Dimensions, Alert, PixelRatio, AppState } from 'react-native'
import { fetchAuthSession } from 'aws-amplify/auth'
import Constants from 'expo-constants'
import * as Location from 'expo-location'
import { StoresListModel, CampaignModel, CampaignScheduleModel, CampaignStepsModel, ActivitysModel } from './models/ScheduleModel'
import { Feather } from '@expo/vector-icons'
import theme from '../../../theme'
import styles from './ScheduleStyles'
import { CampaignView, CustomBar } from './CampaignView'
import { StoresFilterView } from './StoresFilterView'
import { StoreItem } from './StoreItem'
import { CampaignStatus, getStatusMap } from './StatusTagsStores'
import { TagsModel } from '../customUtils/Components/Models/TagsModel'
import { useSchedule } from './hooks/useSchedule'
import { format } from 'date-fns'
import { es, enUS } from 'date-fns/locale'
import { schedulesServices } from '../../../database/schedules.database'
import { distanceInMeters } from '../customUtils/calculateDistance'
import { Loader } from '../customUtils/Components/Loader'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { Calendar } from 'react-native-calendars'
import { useStoreContext } from './context/store.context'
import { getLocation } from '../appBar/context/LocationContext'
import { PostsServices } from '../../../database/posts.database'
import { CONSTANTS_TYPES_STEPS, STORE_STATUS } from './constants/constants.stores'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
import { SearchStores } from './components/SearchStores'
import { useFocusEffect, useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { DotsNavigation } from '../navigation/stacks/NavigationStack'
import { Ionicons } from '@expo/vector-icons'
import { RefreshControl } from 'react-native-gesture-handler'
import CustomAlert from '../customUtils/Components/CustomAlert'
import { UserServices } from '../../../database/user.database'
import { SCHEDULES_STORE_NAMES } from '../../db/posSchedules'
import AsyncStorage from '@react-native-async-storage/async-storage'
import { usePermissionStore } from '../../redux/zustand/permissions-store'
import { PermissionsAdapter } from '../../utils/permission'
import { getConection } from '../appBar/context/HeaderContext'
import * as ImagePicker from 'expo-image-picker'
import { ASYNC_STORAGE_KEYS } from './constants/constants.storage'
import { SendContact, validateErrorSignOut } from '../../utils/functions.utils'
import { useFormIncidenceStore } from '../../redux/zustand/formIncedenceStore'
import { useCacheClearedStore } from '../../redux/zustand/useCacheClearedStore'

const width = Dimensions.get('window').width

export const Schedule = ({ route }) => {
    const store_id = route?.params?.store_id
    const { languageFile } = getLanguage()
    const permission = usePermissionStore()

    const [refreshing, setRefreshing] = useState(false)
    const { userLat, userLng } = getLocation()
    const [reloadPermission, setReloadPermission] = useState(false)
    const [lastUpdateDate, setLastUpdateDate] = useState(new Date().toDateString())
    const [pendingReload, setPendingReload] = useState(false)
    const expoConfig = Constants.expoConfig || { name: '' }
    useFocusEffect(
        React.useCallback(() => {
            const CameraPermissions = async () => {
                const statusResultCamera = await permission.requestCameraPermission()
                const statusResultMediaLibrary = await permission.requestMediaLibraryPermission()

                if (statusResultCamera === false || statusResultMediaLibrary === false) {
                    setLoading(false)

                    Alert.alert(
                        expoConfig.name + ' quiere acceder a tu camara y galería',
                        expoConfig.name +
                            ' necesita acceso a tu camara y galería para que puedas elegir una foto de perfil o subir imágenes en los relevamientos de las tiendas asignadas.',
                        [
                            {
                                text: 'Cancelar',
                                onPress: async () => {},
                            },
                            {
                                text: 'Configuración',
                                onPress: async () => {
                                    Linking.openSettings()
                                },
                            },
                        ],
                        { cancelable: true },
                    )
                }
                // setLoading(false)
            }

            const requestPermissions = async () => {
                // const servicesEnabled = await Location.hasServicesEnabledAsync()
                const servicesEnabled = await PermissionsAdapter.hasServicesEnabledAsync()
                permission.setLocationEnabled(servicesEnabled)
                let l = await permission.checkPermissions()
                if (!servicesEnabled) {
                    setLoading(false)
                    return
                }

                if (!permission.hasLocationPermission || !permission.hasMediaLibraryPermission) {
                    setLoading(true)
                    // si no tengo, false, pido permisos
                    let { status } = await Location.getForegroundPermissionsAsync()
                    if (status === 'granted') {
                    } else {
                        setLoading(false)
                    }
                } else {
                    if (pendingReload) {
                        reloadCounterFn()
                        fetchDataGetHistoryForms()
                        fetchData()
                        setLastUpdateDate(new Date().toDateString())
                        setPendingReload(false)
                    } else {
                        reloadCounterFn()
                        fetchDataGetHistoryForms()
                        fetchData()
                        setLastUpdateDate(new Date().toDateString())
                    }
                }
            }

            CameraPermissions()
            requestPermissions()
        }, [permission.hasMediaLibraryPermission, permission.hasLocationPermission, reloadPermission, pendingReload]),
    )

    useEffect(() => {
        const handleAppStateChange = (nextAppState) => {
            console.log('AppState changed to:', nextAppState)
            if (nextAppState === 'active') {
                const currentDate = new Date().toDateString()
                console.log('Current date:', currentDate)
                console.log('Last update date:', lastUpdateDate)

                if (currentDate !== lastUpdateDate) {
                    setLoading(true)
                    setReloadPermission((prev) => !prev)
                }
            }
        }

        const subscription = AppState.addEventListener('change', handleAppStateChange)

        return () => subscription?.remove()
    }, [lastUpdateDate])

    const {
        campaign,
        goToForm,
        goToStore,
        loading,
        setLoading,
        generator,
        fetchData,
        messageService,
        reloadCounterFn,
        fetchDataGetHistoryForms,
        showMapButton,
        showCreatePosButton,
        descriptionLoading,
        reloadCounter,
        clearData,
    } = useSchedule() // descomentar esta linea y comentar toda la logica que hay abajo

    const cacheClearedEvent = useCacheClearedStore((state) => state.cacheClearedEvent)
    const resetCacheCleared = useCacheClearedStore((state) => state.resetCacheCleared)

    useEffect(() => {
        if (cacheClearedEvent) {
            clearData()
            setLoading(true)
            setPendingReload(true)
            resetCacheCleared()
        }
    }, [cacheClearedEvent])

    const isCompletedSchedule = async (): Promise<boolean> => {
        let completed = true

        const totalStores = await UserServices.getGlobalVersion(SCHEDULES_STORE_NAMES.COUNT_STORES)
        const totalSchedulePos = await UserServices.getGlobalVersion(SCHEDULES_STORE_NAMES.COUNT_SCHEDULES_POS)
        const totalScheduleForms = await UserServices.getGlobalVersion(SCHEDULES_STORE_NAMES.COUNT_SCHEDULES_FORMS)

        const totalStoresIsCorrect = await schedulesServices.hasStoresInDatabase(totalStores)
        const totalSchedulePosIsCorrect = await schedulesServices.hasSchedulePosInDatabase(totalSchedulePos)
        const totalFormsIsCorrect = await schedulesServices.CheckSavedRecords(SCHEDULES_STORE_NAMES.FORMS, totalScheduleForms)

        const campaigns = await schedulesServices.getAllCampaigns()

        if (!campaigns || campaigns.length == 0) {
            console.log('no hay campañas')
            completed = false
        }

        if (!totalStoresIsCorrect) {
            console.log('no hay tiendas')
            completed = false
        }

        if (!totalSchedulePosIsCorrect) {
            console.log('no hay pos')
            completed = false
        }

        if (!totalFormsIsCorrect) {
            console.log('no hay forms')
            completed = false
        }

        return completed
    }

    const onRefresh = async (clear = false) => {
        console.log('estoy acaaaaaa en el refresssh')
        try {
            setRefreshing(true)
            setLoading(true)

            if (clear) {
                //envio un contact a base
                try {
                    let send = await SendContact('REINTENTAR', 'REINTENTAR', 'Soporte', userLat, userLng)
                } catch (error) {
                    console.error('🚀 ~ onRefresh ~ error:', error)
                }
                await AsyncStorage.setItem(ASYNC_STORAGE_KEYS.STOP_PROCESS_SCHEDULE, 'false')
                console.log('elimino datos de agendaa')
                await UserServices.updateGlobalVersion(SCHEDULES_STORE_NAMES.SCHEDULES_VERSION, null)
                await schedulesServices.deleteAllTablesSchedule()
            }
            fetchData()
                .catch(async (error) => {
                    const isCompleted = await isCompletedSchedule()
                    console.log('209 -- 🚀 ~ onRefresh ~ isCompleted:', isCompleted)
                    if (!isCompleted) {
                        await validateErrorSignOut(error)
                    }
                })
                .finally(() => {
                    setLoading(false)
                    console.log('estoy refrescando ========> setLoading false')
                })
        } catch (error) {
            console.error('168 ---- onRefresh: ', error)
        } finally {
            setRefreshing(false)
        }
    }

    if (!loading && !permission.hasLocationPermission) {
        return (
            <View style={styles.containerNoProducts}>
                <Image style={styles.image} source={require('../../../assets/noConnection.png')} />
                <Text style={styles.title}>Tienes los permisos de ubicación desactivados</Text>
                <Text style={styles.description}>Para habilitar esta sección, debés activar los permisos de ubicación de la App.</Text>
                <View style={styles.spacer}></View>
                <TouchableOpacity style={styles.mainButtonRetry} onPress={() => Linking.openSettings()}>
                    <Text style={styles.mainButtonTextRetry}>Activar</Text>
                </TouchableOpacity>
            </View>
        )
    }

    if (!loading && !permission.hasMediaLibraryPermission) {
        return (
            <View style={styles.containerNoProducts}>
                <Image style={styles.image} source={require('../../../assets/noGalleria.png')} />
                <Text style={styles.title}>Tienes los permisos de galería desactivados</Text>
                <Text style={styles.description}>Para habilitar esta sección, debés activar los permisos de galería de la App.</Text>
                <View style={styles.spacer}></View>
                <TouchableOpacity style={styles.mainButtonRetry} onPress={() => Linking.openSettings()}>
                    <Text style={styles.mainButtonTextRetry}>Activar</Text>
                </TouchableOpacity>
            </View>
        )
    }

    if (!loading && !permission.locationEnabled) {
        return (
            <View style={styles.containerNoProducts}>
                <Image style={styles.image} source={require('../../../assets/noConnection.png')} />
                <Text style={styles.title}>Activa la ubicación</Text>
                <Text style={styles.description}>Para habilitar esta sección, debés activar la ubicación del dispositivo</Text>

                <TouchableOpacity style={styles.mainButtonRetry} onPress={() => setReloadPermission(!reloadPermission)}>
                    <Text style={styles.mainButtonTextRetry}>Actualizar</Text>
                </TouchableOpacity>
            </View>
        )
    }
    // if (!loading && (userLat == null || userLat == 0) && (userLng == null || userLng == 0)) {
    //     return (
    //         <View style={styles.containerNoProducts}>
    //             <Image
    //                 source={require('../../../assets/circleLoader.gif')} // Usa la importación del GIF
    //                 style={{ width: width / 6, height: width / 6 }} // Ajusta el tamaño según necesites
    //                 resizeMode='contain' // O "cover", dependiendo de cómo quieras que se ajuste
    //             />
    //             <Text style={styles.title}>Recuperando tu ubicación</Text>
    //             <Text style={styles.description}>Espera un momento</Text>
    //         </View>
    //     )
    // }

    const messageParts = messageService.split('\n')

    const messageFirstPart = messageParts[0] // 'Cargando tiendas...'
    const messageSecondPart = messageParts[1] // 'Este proceso podría demorar unos minutos.'

    return loading ? (
        <>
            {/*<Loader />*/}
            <View style={styles.containerGif}>
                <Image
                    source={require('../../../assets/circleLoader.gif')} // Usa la importación del GIF
                    style={{ width: width / 6, height: width / 6 }} // Ajusta el tamaño según necesites
                    resizeMode='contain' // O "cover", dependiendo de cómo quieras que se ajuste
                />
                <Text style={styles.title}>{messageFirstPart}</Text>
                {descriptionLoading && descriptionLoading != '' ? (
                    <Text style={styles.description}>{descriptionLoading}</Text>
                ) : (
                    <Text style={styles.description}>{messageSecondPart}</Text>
                )}
            </View>
            {/*descriptionLoading && descriptionLoading != '' && <Text>{descriptionLoading}</Text>
            {messageService && messageService != '' && (
                <View style={{ flexDirection: 'row' }}>
                    <CustomAlert
                        visible={true}
                        backgroundColor={'rgba(0, 0, 0, 0.7)'}
                        textColor={'white'}
                        nameIcon={'refresh-cw'}
                        message={messageService}
                    />
                </View>
            )}
            {{messageService && messageService != '' && <Text>{messageService}</Text>} */}
        </>
    ) : (
        <View style={styles.container}>
            {campaign && campaign.length > 0 ? (
                <>
                    <FlatList
                        refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} progressViewOffset={10} />}
                        data={campaign}
                        horizontal={false}
                        showsVerticalScrollIndicator={false}
                        renderItem={({ item: campaign }) => (
                            <CampaignList
                                campaign={campaign}
                                onClickGoForm={goToForm}
                                onClickGoStore={goToStore}
                                generator={generator}
                                onRefresh={onRefresh}
                                gotoStore={store_id}
                                showMapButton={showMapButton}
                                showCreatePosButton={showCreatePosButton}
                                reloadData={reloadCounter}
                            />
                        )}
                        numColumns={1}
                    />
                </>
            ) : (
                <>
                    <View style={styles.containerNoProducts}>
                        <Image style={styles.image} source={require('../../../assets/noAgendaWeek.png')} />
                        <Text style={styles.title}>{languageFile.no_agenda_week}</Text>
                        <Text style={styles.description}>{languageFile.no_information_week}</Text>
                        <TouchableOpacity style={styles.mainButtonRetry} onPress={() => onRefresh(true)}>
                            <Text style={styles.mainButtonTextRetry}>{languageFile.retry}</Text>
                        </TouchableOpacity>
                        {/* {generator && generator.active && !generator.is_moderator && (
                            <TouchableOpacity style={styles.formButton} onPress={() => goToCreateSchedule()}>
                                <Text style={styles.mainButtonText}>{generator.title ?? ''}</Text>
                            </TouchableOpacity>
                        )} */}
                    </View>
                </>
            )}
        </View>
    )
}

export const CampaignList = ({
    campaign,
    onClickGoForm,
    onClickGoStore,
    generator,
    onRefresh,
    gotoStore,
    showMapButton,
    showCreatePosButton,
    reloadData,
}) => {
    const expoConfig = Constants.expoConfig || { slug: '' }
    const { stores, setStores } = useStoreContext()
    const { openBottomSheet, closeBottomSheet } = useBottomSheet()
    const [form, setForm] = useState(null)
    const mainViewRef = useRef(null)
    const [selectedSchedule, setSelectedSchedule] = useState(null)
    // console.log('🚀 ~ CampaignList ~ selectedSchedule:', selectedSchedule)
    const [selectedScheduleTags, setSelectedScheduleTags] = useState([])
    const [page, setPage] = useState(0)
    const [size] = useState(30)
    const [tagID, setTagID] = useState(-1)
    const navigation = useNavigation<StackNavigationProp<DotsNavigation>>()
    // const [stores, setStores] = useState([])
    const { userLat, userLng, setUserLat, setUserLng, checkLocation, askAgain } = getLocation()
    const [userLocation, setUserLocation] = useState({ lat: userLat, lng: userLng })
    const [initialLocation, setInitialLocation] = useState({ lat: userLat, lng: userLng })
    const [loading, setLoading] = useState(true)
    const { languageFile } = getLanguage()
    const statusMap = getStatusMap(languageFile)
    const [dateSelected, setDateSelected] = useState({ date_init: null, date_finish: null })
    const [showCalendar, setShowCalendar] = useState(false)
    const [showAlert, setShowAlert] = useState(false)
    const [showNoStores, setShowNoStores] = useState(false)
    const [firstLoad, setFirstLoad] = useState(true)
    const [buttonDistributor, setButtonDistributor] = useState(null)
    const [listActivities, setListActivities] = useState([])
    const [listOthesActivities, setListOthesActivities] = useState([])
    const [dateString, setDateString] = useState(null)
    const setFormIncidence = useFormIncidenceStore((state) => state.setFormIncidence)
    // let fecha_hoy = new Date()
    // let offset = fecha_hoy.getTimezoneOffset()
    // // Convertir la fecha y hora actual de UTC a la zona horaria local del usuario
    // fecha_hoy.setMinutes(fecha_hoy.getMinutes() - offset)
    const [dateTodayLocal, setDayTodayLocal] = useState(null)
    // console.log('🚀 ~ CampaignList ~ dateTodayLocal:', fecha_hoy, offset, dateTodayLocal)

    const [markedDates, setMarkedDates] = useState({})
    const handleSelectLabel = (labelId) => {
        if (labelId !== tagID) {
            setTagID(labelId)
            setStores([])
            setPage(0)
            let newTags = selectedSchedule.tags.map((tag) => {
                if (tag._id === String(labelId)) {
                    return { ...tag, isSelected: true }
                } else {
                    return { ...tag, isSelected: false }
                }
            })
            setSelectedSchedule((prevSchedule) => ({
                ...prevSchedule,
                tags: newTags,
            }))
        }
        mainViewRef.current?.scrollToOffset({ offset: 0, animated: true })
    }

    const getStores = async (counter_stores = 1) => {
        console.log('estoy en get_store', counter_stores)
        try {
            await checkForms(selectedSchedule, dateSelected.date_init)
            if (selectedSchedule) {
                const radius = 5000 // Radio de búsqueda en metros (5 km)
                await schedulesServices
                    .getStoresFromSchedule(
                        page,
                        size,
                        selectedSchedule._id,
                        tagID,
                        initialLocation.lat,
                        initialLocation.lng,
                        radius,
                        campaign.schedule_free,
                        dateSelected?.date_init,
                    )
                    .then((newStores) => {
                        newStores.forEach((store) => {
                            store.distance = distanceInMeters(userLocation.lat, userLocation.lng, store.lat, store.lng)
                        })

                        if (page > 0) {
                            setStores((prevStores) => {
                                const combinedStores = [...prevStores, ...newStores]
                                return combinedStores
                            })
                        } else {
                            if (newStores && newStores.length > 0) {
                                setStores(newStores)
                            }
                            if (newStores.length == 0) {
                                if (counter_stores != null && counter_stores < 3) {
                                    getStores(counter_stores + 1)
                                } else {
                                    setShowNoStores(true)
                                }
                            } else {
                                setShowNoStores(false)
                            }
                        }
                    })
            }
        } catch (error) {
            console.error(error)
            setLoading(false)
        }
    }

    const handleEndReachedStores = () => {
        if (selectedSchedule) {
            if (stores.length >= size) {
                setPage((prevPage) => prevPage + 1)
            }
        }
    }
    const updateScheduleTags = async (todaySchedule) => {
        try {
            const newTags = []
            if (todaySchedule && todaySchedule?._id) {
                await schedulesServices.getProgressStatus(todaySchedule?._id, statusMap).then((campaignStatus) => {
                    campaignStatus.forEach((status) => {
                        let newTag = createTag(status?._id, languageFile)
                        if (newTag) {
                            if (!newTags.some((tag) => tag._id === newTag._id)) {
                                newTags.push(newTag)
                            }
                        }
                    })
                    if (newTags.length > 0) {
                        let todos = { title: languageFile.all, image: '', _id: '-1', isSelected: true }
                        newTags.unshift(todos)
                        setSelectedSchedule((prevSchedule) => ({
                            ...prevSchedule,
                            tags: newTags,
                        }))
                    }
                    if (firstLoad) {
                        setSelectedSchedule((prevSchedule) => ({
                            ...prevSchedule,
                            tags: newTags,
                        }))
                    } else {
                        const updatedTags = newTags.filter((tag) => !selectedSchedule?.tags.some((t) => t._id === tag._id))
                        const mergedTags = [...selectedSchedule.tags, ...updatedTags]

                        setSelectedSchedule((prevSchedule) => ({
                            ...prevSchedule,
                            tags: mergedTags,
                        }))
                    }

                    setFirstLoad(false)
                })
            }
        } catch (error) {
            console.error('error en tags', error)
        }
    }

    const filterDay = (date) => {
        // console.log('🚀 ~ filterDay ~ date:', date)
        try {
            const today = date ? new Date(date) : new Date() //new Date(date.getFullYear(), date.getMonth(), date.getDate())
            console.log('🚀 ~ filterDay ~ today:', today)

            if (campaign?.schedules && campaign?.schedules.length > 0) {
                // Encontrar el horario de hoy en las campañas
                const todaySchedule = campaign.schedules.find((schedule) => {
                    // Convertir las fechas de inicio y fin del horario a fecha local
                    const scheduleDateInit = new Date(schedule.date_init)
                    const scheduleDateFinish = new Date(schedule.date_finish)

                    // Verificar si la fecha de hoy está dentro del rango del horario
                    return scheduleDateInit <= today && scheduleDateFinish >= today
                })

                // console.log('----------------- tengo agendaaaaa ------------------ ????? => ', todaySchedule)
                if (todaySchedule) {
                    if (todaySchedule.progress_diary) {
                        // Si hay diario de progreso, establecer inicio y fin del día actual
                        let fecha_hoy = new Date()
                        let offset = fecha_hoy.getTimezoneOffset()
                        // Convertir la fecha y hora actual de UTC a la zona horaria local del usuario
                        fecha_hoy.setMinutes(fecha_hoy.getMinutes() - offset)
                        setDateSelected({
                            date_init: new Date(fecha_hoy.setUTCHours(0, 0, 0, 0)).toISOString(),
                            date_finish: new Date(fecha_hoy.setUTCHours(23, 59, 59, 999)).toISOString(),
                        })
                    } else {
                        // Establecer inicio y fin del horario encontrado
                        setDateSelected({
                            date_init: new Date(todaySchedule.date_init).toISOString(),
                            date_finish: new Date(todaySchedule.date_finish).toISOString(),
                        })
                    }
                    // console.log('🚀 ~ filterDay ~ todaySchedule:', todaySchedule)
                    setSelectedSchedule(todaySchedule)
                    // Realizar otras operaciones necesarias con el horario seleccionado
                    updateScheduleTags(todaySchedule)
                } else {
                    console.log('No se encontró ningúna agenda para hoy, limpiar datos')
                    setLoading(false)
                    setLoading(false)
                    setStores([])
                    setSelectedSchedule(null)
                }
            }
        } catch (error) {
            console.error(error)
        }
    }

    const selectDay = async (day) => {
        const selectDate = new Date(day.dateString)
        console.log('🚀 ~ selectDay ~ selectDate:', selectDate)

        const endOfDay = selectDate
        endOfDay.setUTCHours(23, 59, 59, 999)

        setDateSelected({
            date_init: new Date(day.dateString).toISOString(),
            date_finish: endOfDay.toISOString(),
        })
        formatDate(endOfDay.toISOString())
        setStores([])
        setPage(0)
        let allSelectedDates = {
            // ...vacations,
            [day.dateString]: { selected: true, marked: true, selectedColor: theme.colors.colorPrimary },
        }
        setMarkedDates(allSelectedDates)

        // Llamar a filterDay con selectedDate
        filterDay(selectDate)
    }

    const checkForms = async (schedule, today) => {
        try {
            if (schedule) {
                const { form_init, form_finish, _id, distributor, activities, others_activities, forms_incidence } = schedule

                if (form_init && form_finish && _id) {
                    const form_id_init = form_init?._id
                    const form_id_finish = form_finish?._id
                    const formInitStatus = await schedulesServices.getFormStatusFromAdvances(_id, form_id_init, dateSelected)
                    const formFinishStatus = await schedulesServices.getFormStatusFromAdvances(_id, form_id_finish, dateSelected)

                    let form_to_send = null

                    if (!formInitStatus) {
                        //si no hizo matutino
                        form_to_send = {
                            _id: form_id_init,
                            schedule_id: _id,
                            name: '1.1 Matutino',
                            completed: false,
                        }
                        if (campaign.steps && campaign.steps.length > 0) {
                            const step = campaign.steps.find((step) => step.type === CONSTANTS_TYPES_STEPS.BLOCKED_ROUTE)
                            if (step) {
                                form_to_send.progressive_mode = true
                                // const stepDateInit = new Date(step.date_init).toISOString().split('T')[0]
                                // const stepDateFinish = new Date(step.date_finish).toISOString().split('T')[0]
                                // if (stepDateInit <= today && stepDateFinish >= today && step.forms.some((item) => item._id === form_id_init)) {
                                //     form_to_send.progressive_mode = true
                                // }
                            }
                        }
                        //setForm({ ...form_init, schedule_id: _id })
                    } else if (form_finish) {
                        if (!formFinishStatus) {
                            form_to_send = {
                                _id: form_id_finish,
                                schedule_id: _id,
                                name: '1.1 Vespertino',
                                completed: false,
                            }
                            // setForm({ ...form_finish, schedule_id: _id })
                        }
                    }
                    setForm(form_to_send)
                } else {
                    if (distributor && activities) {
                        setListActivities(activities)
                        // @fixme pisar por las que van
                        setListOthesActivities(others_activities)
                        setButtonDistributor(distributor)
                    }

                    if (forms_incidence && forms_incidence.length > 0) {
                        const getFormIncidence = await schedulesServices.getForm(forms_incidence)
                        setFormIncidence(getFormIncidence)
                    }
                }
            }
        } catch (error) {
            console.error(error)
        }
    }

    const handleSearchStores = async () => {
        // mostrar esto:
        console.log('handleSearchStores')
        const snapPoints = ['70%']

        openBottomSheet(
            <SearchStores
                selectedSchedule={selectedSchedule}
                initialLocation={initialLocation}
                userLocation={userLocation}
                campaign={campaign}
                onClickGoStore={(store) =>
                    onClickGoStore(
                        store._id,
                        store.forms,
                        selectedSchedule._id,
                        campaign?.steps,
                        store.forms_relevant,
                        store.forms_advances,
                        store.distance,
                        store.campaign_status,
                    )
                }
            />,
            snapPoints,
        )
    }
    // const timeZoneOffset = new Date().getTimezoneOffset() * 60000 // Offset en milisegundos
    // console.log('0~ TimeZone Offset (minutos):', timeZoneOffset / 60000)

    // const date = dateSelected.date_finish ? new Date(dateSelected.date_finish) : new Date()
    // console.log('1~ CampaignList ~ date (original UTC):', date)

    // // Ajustar la fecha a la zona horaria local
    // const localDate = new Date(date.getTime() - timeZoneOffset)
    // console.log('2 ~ CampaignList ~ localDate:', localDate)

    // // Extraer sólo la parte de la fecha
    // const localStartDate = new Date(localDate.getFullYear(), localDate.getMonth(), localDate.getDate())
    // console.log('3~ CampaignList ~ localStartDate:', localStartDate)

    // // Formatear la fecha
    // const dayDate = format(localStartDate, 'EEEE d', { locale: es })
    // console.log('4 ~ CampaignList ~ dayDate:', dayDate)

    // const monthYearDate = format(localStartDate, "'de' MMMM yyyy", { locale: es })
    // console.log('5 ~ CampaignList ~ monthYearDate:', monthYearDate)
    // const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    // console.log('6 ~ TimeZone:', timeZone)

    // const date = dateSelected.date_finish ? new Date(dateSelected.date_finish) : new Date()
    const formatDate = (date) => {
        console.log('0 ~ formatDate ~ date:', date)
        try {
            let dayDate = format(date, 'EEEE d', { locale: es })
            let monthYearDate = format(date, "'de' MMMM yyyy", { locale: es })
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
            setDateString({ dayDate, monthYearDate })
        } catch (error) {
            console.error('🚀 ~ formatDate ~ error:', error)
        }
    }

    const goToAddStores = () => {
        navigation.navigate('AddStores', { schedule_id: selectedSchedule._id, distributor_id: buttonDistributor._id })
    }
    const [pitchActive, setPitchActive] = useState(false)

    useFocusEffect(
        React.useCallback(() => {
            let fecha_hoy = new Date()
            let offset = fecha_hoy.getTimezoneOffset()
            // Convertir la fecha y hora actual de UTC a la zona horaria local del usuario
            fecha_hoy.setMinutes(fecha_hoy.getMinutes() - offset)
            setDayTodayLocal(fecha_hoy)
            formatDate(fecha_hoy)
            filterDay(fecha_hoy)
        }, []),
    )
    useEffect(() => {
        askAgain()
        if (campaign) {
            //filterDay(dateTodayLocal)
        }
        const getLocation = async () => {
            let { status } = await Location.requestForegroundPermissionsAsync()
            if (status !== 'granted') {
                console.error('Permission to access location was denied')
                return
            }

            let location = await Location.getCurrentPositionAsync({})
            const { latitude, longitude } = location.coords
            setUserLocation({ lat: latitude, lng: longitude })

            return { lat: latitude, lng: longitude }
        }

        getLocation()

        if (!userLat || !userLng) {
            console.log('user en ceroooo')
            let user = PostsServices.getUser().then((user) => {
                if (user.lat && user.lng) {
                    setUserLat(user.lat)
                    setUserLng(user.lng)
                    setInitialLocation({ lat: user.lat, lng: user.lng })
                    setUserLocation({ lat: user.lat, lng: user.lng })
                }
            })
        }

        //
        let location = checkLocation()
        // if (location) {
        //     //   const distanceMoved = distanceInMeters(initialLocation.lat, initialLocation.lng, location.lat, location.lng)
        //     // if (distanceMoved >= 0) {
        //     // setInitialLocation(location)
        //     // }
        // }
        // }, [campaign])
    }, [campaign])

    useEffect(() => {
        if (userLocation.lat !== null && userLocation.lng !== null && dateSelected?.date_init != null && selectedSchedule) {
            //setLoading(true)
            getStores()
                .finally(() => {
                    setLoading(false)
                    checkNavigation()
                })
                .catch((error) => console.error(error))
        }
        try {
            if (!dateSelected || !dateSelected.date_init) {
                return
            } else {
                const dateInit = dateSelected.date_init
                const todayLocalDate = dateTodayLocal.toISOString().split('T')[0]

                // Verificar si dateInit es una cadena antes de usar split
                if (typeof dateInit === 'string' && dateInit.split('T')[0] !== todayLocalDate) {
                    setShowAlert(true)
                } else {
                    setShowAlert(false)
                }
            }
        } catch (error) {
            console.log('🚀 ~ useEffect ~ error:', error)
        }
    }, [dateSelected, tagID, page])

    const checkNavigation = async () => {
        let hasNavigated = await AsyncStorage.getItem('hasNavigatedToStore')
        const isNavigatedToStore = hasNavigated == 'true'
        if (gotoStore && !isNavigatedToStore) {
            let go_to = JSON.parse(gotoStore)

            schedulesServices
                .getStoreForGoto(go_to.post_id)
                .then(async (store) => {
                    if (store) {
                        let params_store = {
                            storeID: go_to.post_id,
                            forms: JSON.parse(store.forms),
                            scheduleID: store.schedule_id,
                            steps: null,
                            forms_relevant: [],
                            forms_advances: JSON.parse(store.forms_advances),
                            distance: 0,
                            store_status: store.campaign_status,
                            navigate_form: go_to.id_form ? go_to.id_form : null,
                        }

                        // Navegar a la tienda
                        navigation.navigate('StoreDetail', params_store)

                        // Guardar el estado en AsyncStorage para persistencia
                        await AsyncStorage.setItem('hasNavigatedToStore', 'true')
                    } else {
                        console.log('================NO ESTA LA TIENDA====================')
                    }
                })
                .catch((error) => {
                    console.error(error)
                })
        }
    }

    const renderActivity = ({ item }) => (
        <TouchableOpacity style={styles.buttonCheck} onPress={() => handleCheckActivity(item._id)}>
            <Ionicons name={item.status === 3 ? 'checkbox-outline' : 'square-outline'} size={24} color={'black'} style={styles.marginLeftBis} />
            <Text style={item.status === 3 ? styles.activityStrikethrough : styles.activity}>{item.title}</Text>
        </TouchableOpacity>
    )

    const handleCheckActivity = (activityId) => {
        setListOthesActivities((prevActivities) =>
            prevActivities.map((activity) => {
                if (activity._id === activityId) {
                    if (activity.status === 1) {
                        // Cambiamos el status a 3 y abrimos el modal para ingresar un comentario

                        return { ...activity, status: 3 }
                    } else if (activity.status === 3) {
                        // Si ya está en status 3,no hago nada
                    }
                }
                return activity
            }),
        )
    }

    const navigateToCreateStore = () => {
        try {
            const params = {
                schedule_id: selectedSchedule._id,
            }
            navigation.navigate('CreateStoreScreen', params)
        } catch (error) {
            console.error('navigateToCreateStore => error => ', error)
        }
    }

    const [showOthersActivities, setOthersShowActivities] = useState(false)
    const [openPicker, setOpenPicker] = useState(false)

    const [iconSize, setIconSize] = useState(16)

    // Detectar si el tamaño de la fuente ha sido aumentado
    useEffect(() => {
        const fontScale = 1
        if (fontScale > 1) {
            setIconSize(24) // Cambiar iconSize si el tamaño de la fuente es más grande
        } else {
            setIconSize(20) // Valor normal
        }
    }, [])
    return (
        <View style={styles.container}>
            {campaign && expoConfig.slug != 'kimberly-one' ? (
                <CampaignView
                    campaignValues={campaign.values}
                    campaignProgress={campaign.total_progress}
                    date={''}
                    finishDate={campaign.date_finish}
                    form={form}
                    steps={campaign.steps}
                    schedule_id={selectedSchedule?._id}
                    schedule={selectedSchedule}
                    showAlert={showAlert}
                    selectedDate={dateSelected}
                    selectDay={selectDay}
                    scheduleFree={campaign.schedule_free ?? false}
                    generator={generator}
                    buttonDistributor={buttonDistributor}
                    activities={listActivities}
                    showMapButton={showMapButton}
                />
            ) : (
                <View style={{ height: 10 }} />
            )}
            {listOthesActivities && listOthesActivities.length > 0 ? (
                <View style={styles.container}>
                    {listOthesActivities.length > 0 ? (
                        <>
                            <TouchableOpacity
                                style={[styles.inputdrop, { marginHorizontal: 12 }]}
                                onPress={() => setOthersShowActivities(!showOthersActivities)}
                            >
                                <Text style={styles.subtitle}>{'Otras actividades'}</Text>
                                <View style={styles.containerRow}>
                                    <Feather
                                        name={showOthersActivities ? 'chevron-up' : 'chevron-down'}
                                        size={iconSize}
                                        color={theme.colors.colorPrimary}
                                    />
                                </View>
                            </TouchableOpacity>

                            {showOthersActivities && (
                                <View style={[styles.inputDropdownMenuSubsection, styles.marginHorizontal]}>
                                    <FlatList
                                        data={listOthesActivities}
                                        renderItem={renderActivity}
                                        keyExtractor={(item) => item._id}
                                        style={styles.list}
                                    />
                                </View>
                            )}
                        </>
                    ) : (
                        <Text style={styles.noActivitiesText}>No hay actividades disponibles.</Text>
                    )}
                </View>
            ) : null}

            <View style={styles.containerIconButtons}>
                {campaign.schedules.length > 0 && dateString ? (
                    <Text style={expoConfig.slug != 'jti-connect' ? styles.textDate : styles.textDateJTI}>
                        <Text style={styles.bold}>{dateString.dayDate + ' '}</Text>
                        <Text style={styles.normal}>{dateString.monthYearDate}</Text>
                    </Text>
                ) : (
                    <View style={styles.container} />
                )}

                <View style={styles.flexDirectionRowBis}>
                    <TouchableOpacity style={styles.iconButton} onPress={() => checkLocation()}>
                        <Feather name='refresh-ccw' size={iconSize} color={theme.colors.textPrimary} />
                    </TouchableOpacity>
                    <TouchableOpacity
                        style={[styles.iconButton, (form && !form.completed && form.progressive_mode) || showAlert ? { opacity: 0.5 } : null]}
                        onPress={(form && !form.completed && form.progressive_mode) || showAlert ? () => {} : handleSearchStores}
                    >
                        <Feather name='search' size={iconSize} color={theme.colors.textPrimary} />
                    </TouchableOpacity>

                    {campaign.schedules.length > 1 && (
                        <TouchableOpacity style={styles.iconButton} onPress={() => setShowCalendar(!showCalendar)}>
                            <Feather name='calendar' size={iconSize} color={theme.colors.textPrimary} />
                        </TouchableOpacity>
                    )}

                    {showCreatePosButton && (
                        <TouchableOpacity style={styles.iconButton} onPress={navigateToCreateStore}>
                            <Feather name='plus' size={iconSize} color={theme.colors.textPrimary} />
                        </TouchableOpacity>
                    )}
                </View>
            </View>

            {showCalendar && (
                <Calendar
                    onDayPress={(day) => {
                        setShowCalendar(false)
                        selectDay(day)
                    }} //selectDay
                    markedDates={markedDates}
                    theme={{
                        backgroundColor: 'white',
                        calendarBackground: 'white',
                        textSectionTitleColor: theme.colors.textPrimary,
                        selectedDayBackgroundColor: theme.colors.colorPrimary,
                        selectedDayTextColor: 'white',
                        todayTextColor: theme.colors.textSecondary,
                        todayBackgroundColor: theme.colors.disabled,
                        todayDotColor: 'white',
                        dayTextColor: theme.colors.textPrimary,
                        textDisabledColor: theme.colors.mediumGray,
                        arrowColor: theme.colors.colorPrimary,
                    }}
                    style={{
                        marginHorizontal: 12,
                    }}
                    current={new Date().toISOString()}
                />
            )}
            {selectedSchedule ? (
                <>
                    {selectedSchedule.vacation && selectedSchedule.vacation == true ? (
                        <ScheduleVacationAlert />
                    ) : (
                        <View
                            style={(form && !form.completed && form.progressive_mode) || showAlert ? styles.blockedView : null}
                            pointerEvents={(form && !form.completed && form.progressive_mode) || showAlert ? 'none' : null}
                        >
                            <StoresList
                                stores={stores ?? []}
                                date={selectedSchedule?.date_init}
                                tags={selectedSchedule?.tags ?? []}
                                onClickGoStore={(store) =>
                                    onClickGoStore(
                                        store._id,
                                        store.forms,
                                        selectedSchedule._id,
                                        campaign?.steps,
                                        store.forms_relevant,
                                        store.forms_advances,
                                        store.distance,
                                        store.campaign_status,
                                        store.incidence_answer,
                                    )
                                }
                                onEndReached={() => handleEndReachedStores()}
                                selectedTag={(id) => handleSelectLabel(id)}
                                loading={loading}
                                route={selectedSchedule?.additional?.route}
                                showNoStores={buttonDistributor ? false : showNoStores}
                                onRefresh={onRefresh}
                            />
                            {/* {buttonDistributor && stores.length == 0 && (
                            <View style={styles.containerNoProductsBis}>
                                <TouchableOpacity onPress={() => goToAddStores()}>
                                    <Image style={[styles.image]} source={require('../../../assets/add_store.png')} />
                                </TouchableOpacity>
                                <Text style={styles.title}>Aún no tienes tiendas</Text>
                                <Text style={styles.description}>Debes agregarlas manualmente usando el botón '+'</Text>
                            </View>
                        )} */}
                        </View>
                    )}
                </>
            ) : (
                <>
                    {!loading ? (
                        <View style={styles.containerNoProductsBis}>
                            <Image style={styles.image} source={require('../../../assets/no_hay_agenda_tiendas.png')} />
                            <Text style={styles.title}>{languageFile.no_agenda_for_today}</Text>
                            <Text style={styles.description}>{languageFile.consult_your_supervisor}</Text>
                            <TouchableOpacity style={styles.mainButtonRetry} onPress={() => onRefresh(true)}>
                                <Text style={styles.mainButtonTextRetry}>{languageFile.retry}</Text>
                            </TouchableOpacity>
                        </View>
                    ) : (
                        <Loader />
                    )}
                </>
            )}
        </View>
    )
}
export const PitchModal = ({ image, title, desc, acceptModal, cancel }) => {
    const [text, setText] = useState('')

    return (
        <View>
            <Text>Pitch de cuenta</Text>
            <Text>{title}</Text>
            <Text>{desc}</Text>
            <TextInput onChangeText={(text) => setText(text)} value={text} placeholder='Ingresa un comentario ....' multiline={true} />
            <TouchableOpacity onPress={() => acceptModal(text)}>
                <Text>Aceptar</Text>
            </TouchableOpacity>
            <TouchableOpacity onPress={() => cancel()}>
                <Text>Cancelar</Text>
            </TouchableOpacity>
        </View>
    )
}
export const ScheduleVacationAlert = () => {
    return (
        <>
            <View style={styles.containerOnVacation}>
                <Image style={styles.image} source={require('../../../assets/stores/onVacation.png')} />
                <Text style={styles.title}>¡A disfrutar!</Text>
                <Text style={styles.description}>
                    Estás en período de vacaciones, no podrás visualizar o realizar agendas. Nos vemos a la vuelta ¡buenas vacaciones!
                </Text>
            </View>
        </>
    )
}
interface StoresListProps {
    stores?: StoresListModel[]
    date?: string
    tags?: TagsModel[]
    onClickGoStore?: (store: StoresListModel) => void
    onEndReached?: () => void
    selectedTag?: (id: number) => void
    loading?: boolean
    route?: string
    showNoStores?: boolean
    onRefresh?: (clear?: boolean) => void
}
export const StoresList = ({
    stores,
    date,
    tags,
    onClickGoStore,
    onEndReached,
    selectedTag,
    loading,
    route,
    showNoStores,
    onRefresh,
}: StoresListProps) => {
    const { languageFile } = getLanguage()
    const [buttonRecargarDisabled, setButtonRecargarDisabled] = useState(false)
    const filterByTag = (tag: TagsModel) => {
        selectedTag(Number(tag._id))
    }
    const expoConfig = Constants.expoConfig || { slug: '' }

    const validateTags = () => {
        const allTag = tags && tags.length && tags.find((tag) => tag._id == '-1')
        if (allTag != null && allTag != undefined && stores && stores.length == 0) {
            setButtonRecargarDisabled(true)
        }
    }

    useEffect(() => {
        validateTags()
    }, [])

    return (
        <View style={styles.container}>
            {/* <Text style={[styles.textDate, { paddingHorizontal: 10 }]}>{date}</Text> */}
            {expoConfig.slug != 'kimberly-one' && (
                <ScrollView horizontal={true} showsHorizontalScrollIndicator={false} style={styles.scrollView}>
                    <View style={styles.containerStoresFilter}>
                        <StoresFilterView tags={tags} onClickTag={filterByTag} />
                    </View>
                </ScrollView>
            )}
            {stores && stores.length > 0 ? (
                <FlatList
                    style={styles.flatList}
                    data={stores}
                    extraData={stores}
                    initialNumToRender={10}
                    // ref={mainViewRef}
                    keyExtractor={(item, index) => index.toString()}
                    horizontal={false}
                    showsVerticalScrollIndicator={false}
                    renderItem={({ item: stores }) => <StoreItem key={stores?._id} store={stores} onClickGoStore={onClickGoStore} route={route} />}
                    numColumns={1}
                    onEndReached={() => onEndReached()}
                    onEndReachedThreshold={1}
                    ListFooterComponent={loading && <Loader />}
                />
            ) : (
                <>
                    {showNoStores && (
                        <View style={styles.containerNoProductsBis}>
                            <Image style={styles.image} source={require('../../../assets/noAgendaWeek.png')} />
                            <Text style={styles.title}>{languageFile.no_agenda_for_today}</Text>
                            <Text style={styles.description}>{languageFile.consult_your_supervisor}</Text>
                            {buttonRecargarDisabled && (
                                <TouchableOpacity style={styles.mainButtonRetry} onPress={() => onRefresh(true)}>
                                    <Text style={styles.mainButtonTextRetry}>{languageFile.retry}</Text>
                                </TouchableOpacity>
                            )}
                        </View>
                    )}
                </>
            )}
        </View>
    )
}

export const createTag = (status: number, languageFile) => {
    try {
        switch (status) {
            case CampaignStatus?.STATUS_FORM_PENDING:
                return {
                    title: languageFile?.pending_mayus,
                    image: '',
                    _id: String(CampaignStatus.STATUS_FORM_PENDING),
                    isSelected: false,
                    index: 1,
                } as TagsModel
            case CampaignStatus?.STATUS_FORM_APPROVED:
                return {
                    title: languageFile?.visited_mayus,
                    image: '',
                    _id: String(CampaignStatus.STATUS_FORM_APPROVED),
                    isSelected: false,
                    index: 3,
                } as TagsModel
            case CampaignStatus?.STATUS_FORM_PENDING_MODERATION:
                return {
                    title: languageFile?.in_review_mayus,
                    image: '',
                    _id: String(CampaignStatus.STATUS_FORM_PENDING_MODERATION),
                    isSelected: false,
                    index: 5,
                } as TagsModel
            case CampaignStatus.STATUS_FORM_REFUSED:
                return {
                    title: languageFile?.redo_mayus,
                    image: '',
                    _id: String(CampaignStatus.STATUS_FORM_REFUSED),
                    isSelected: false,
                    index: 4,
                } as TagsModel

            case CampaignStatus.STATUS_FORM_IN_PROGRESS:
                return {
                    title: languageFile?.in_progress_mayus,
                    image: '',
                    _id: String(CampaignStatus.STATUS_FORM_IN_PROGRESS),
                    isSelected: false,
                    index: 0,
                } as TagsModel
            case CampaignStatus.STATUS_FORM_PENDING_SYNC:
                return {
                    title: languageFile?.visited_mayus_sync,
                    image: '',
                    _id: String(CampaignStatus.STATUS_FORM_PENDING_SYNC),
                    isSelected: false,
                    index: 2,
                } as TagsModel

            case STORE_STATUS.INCIDENCE_REPORTED_CLOSE:
                return {
                    title: 'CERRADO',
                    image: '',
                    _id: String(STORE_STATUS.INCIDENCE_REPORTED_CLOSE),
                    isSelected: false,
                    index: 6,
                } as TagsModel

            case STORE_STATUS.INCIDENCE_REPORTED_PERMANENTE:
            case STORE_STATUS.INCIDENCE_REPORTED:
                return {
                    title: 'INCIDENCIA',
                    image: '',
                    _id: String(STORE_STATUS.INCIDENCE_REPORTED),
                    isSelected: false,
                    index: 6,
                } as TagsModel
            default:
                console.log('..........................................No tengo status')
                return null
        }
    } catch (error) {
        console.error(error)
    }
}
